import React from 'react';
import { Layout } from 'antd';
const { Footer } = Layout;

const FooterContent = () => {

  return (
    <Footer
      style={{
        textAlign: 'center',
      }}
    >
      onespaai.com ©{new Date().getFullYear()} Created by onespaai.com
    </Footer>
  );

};

export default FooterContent;